module.exports = __webpack_public_path__ + "img/EG.0d0ceeb2.png";